import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'truncate',
  standalone: true
})
export class TruncatePipe implements PipeTransform {
  transform(value: string | null | undefined, max = 20): string {
    if (value == null) return '';
    const str = String(value);
    if (max <= 0) return '';
    if (str.length <= max) return str;
    // Keep max characters and append ellipsis
    return str.slice(0, max).trimEnd() + '...';
  }
}
